/**
 * Console display for use in the Iris environment.
 */
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ConsoleHistoryItemResult(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsxs("div", {
    className: "console-history-item-result",
    children: [/*#__PURE__*/_jsx("div", {
      className: "console-history-gutter",
      children: "-"
    }), /*#__PURE__*/_jsx("div", {
      className: "console-history-content",
      children: children
    })]
  });
}
export default ConsoleHistoryItemResult;
//# sourceMappingURL=ConsoleHistoryItemResult.js.map